// removed by extract-text-webpack-plugin
module.exports = {"faq":"_2eWXWFXR5f_2i8dlG90Hxx","question":"f4A09EFAvRgTVLZKV2UQi"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/snapsell/Faq.scss
// module id = 1614
// module chunks = 0